<template>
      <a-form ref='form' :model='search' class="m-t-20" :style="{'marginBottom':'10px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline' >
        <a-form-item label="关键词" >
          <a-input v-model:value="search.keyword" :style="{width:'240px'}" placeholder="活动ID、活动名称、备注"/>
        </a-form-item>
        <a-form-item label="状态" name='status'>
          <a-select v-model:value="search.status" :style="{width:'140px'}">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="1">未开始</a-select-option>
            <a-select-option value="2">进行</a-select-option>
            <a-select-option value="3">已结束</a-select-option>
            <!-- <a-select-option value="4">已禁用</a-select-option> -->
          </a-select>
        </a-form-item>
        <!-- <a-form-item label="流水号" name='serial_sn'>
          <a-input v-model:value="search.serial_sn" placeholder="请输入流水号" />
        </a-form-item> -->
        <a-form-item>
          <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
        </a-form-item>
      </a-form>
      <div class='m-t-40'>
        <a-table :pagination='false' :loading='listLoading' bordered rowKey='member_id' :columns='columns' :data-source='data' :scroll="{ x: 'max-content'}">
          <template #priority>
            <span>
              优先级
              <a-tooltip placement="right" :get-popup-container="getPopupContainer" :auto-adjust-overflow="false">
                <template #title>
                  <p>优先级数值越大代表优先级越高；若优先级相同，时间越新，优先级越高</p>
                </template>
                <QuestionCircleOutlined />
              </a-tooltip>
            </span>
          </template>
          <template v-slot:priorityContent="{ record }">
                 {{record.sort_level}}
          </template>
          <template v-slot:schedule="{ record }">
            <!-- status="exception" -->
            <a-progress :percent="record.plan" status="active" />{{record.id}}
          </template>
          <template v-slot:action="{ record }">
            <a-button type="primary" @click='select(record)' v-if='!checkout'>选择</a-button>
            <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else>{{!record.select ? "选择":"已选择"}}</a-button>
          </template>
        </a-table>
        <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
      </div>
</template> 
<script>
import { reactive, ref, toRefs, onMounted, inject } from "vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
import { iscode } from "@/utils/app";
import { activitys } from "@/api/qrcodeActivitys";
const def = {
  page: 1,
  limit: 5,
  status: "",
  keyword: "",
  serial_sn: "",
  batch_sn: "",
};
export default {
  name: "selectActivity",
  components: { QuestionCircleOutlined },
  setup(props, { emit }) {
    const state = reactive({
      vipList: [],
      listLoading: false,
      total: 0,
      visible: false,
    });
    let data = ref();
    let columns = [
      {
        title: "活动ID",
        dataIndex: "activity_id",
        key: "activity_id",
      },
      {
        title: "活动名称",
        dataIndex: "activity_name",
        key: "activity_name",
      },
      {
        title: "时间进度",
        key: "schedule",
        width: 230,
        slots: { customRender: "schedule" },
      },
      {
        title: "状态",
        dataIndex: "status_title",
        key: "status_title",
      },
      {
        title: "备注",
        dataIndex: "remarks",
        key: "remarks",
      },
      {
        key: "priority",
        slots: { title: "priority", customRender: "priorityContent" },
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const initData = async (values) => {
      state.listLoading = true;
      let res = await activitys(values).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        data.value = res.data;
        state.total = res.meta.total;
      }
      state.listLoading = false;
    };
    let search = ref({ ...def });
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    onMounted(() => {
      initData(search.value);
    });
    const $router = inject("$router");
    //单选
    const select = (e) => {
      data.value.map((item) => (item.select = false));
      if (e != 0) {
        e.select = !e.select;
      }
      emit("select", e);
    };
    const form=ref('')
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      select,
      form
    };
  },
};
</script>